import { z } from 'zod'

const destinationResponseSchema = z.object({
  name: z.string(),
  slug: z.string(),
})

const moneyResponseSchema = z.object({
  amount: z.number().int(),
  currency: z.enum(['EUR']),
})

const dealResponseSchema = z.object({
  id: z.string(),
  title: z.string(),
  oldPrice: moneyResponseSchema,
  newPrice: moneyResponseSchema,
  discount: z.number(),
})

const mapCottageSchema = z.object({
  id: z.string(),
  cardType: z.string(),
  latitude: z.string(),
  longitude: z.string(),
  name: z.string(),
  slug: z.string(),
  province: destinationResponseSchema,
  village: destinationResponseSchema,
  capacity: z.object({
    min: z.number().int(),
    max: z.number().int(),
  }),
  media: z.object({
    numPhotos: z.number().int(),
    numVideos: z.number().int(),
    thumb: z.string(),
  }),
  review: z.object({
    numReviews: z.number().int(),
    score: z.number(),
  }),
  hasFreeCancellation: z.boolean(),
  hasDeals: z.boolean(),
  currentDeal: dealResponseSchema.nullable(),
  hasVerifiedCalendar: z.boolean(),
  averagePrice: moneyResponseSchema,
  price: moneyResponseSchema.nullable(),
  priceType: z.enum(['EXACT', 'MINIMUM']).nullable(),
  confirmationType: z.enum(['MANUAL', 'IMMEDIATE']).nullable(),
})

export const schema = z.object({
  cottages: z.array(mapCottageSchema),
  totalResults: z.number().int(),
})

export type schemaType = z.infer<typeof schema>
export type MapCottageType = z.infer<typeof mapCottageSchema>
export type DestinationType = z.infer<typeof destinationResponseSchema>
export type MoneyType = z.infer<typeof moneyResponseSchema>
export type DealType = z.infer<typeof dealResponseSchema>
